import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { InventoryDetails } from 'parts/components/PartDetails/Inventory/InventoryDetails';
import { IPurchaseOrderDetail } from 'parts/types';

import { columnDef } from './columns';

interface IProps {
  records: IPurchaseOrderDetail[];
  onClose: () => void;
  isOpen: boolean;
}

export const PurchaseOrders = ({ records, onClose, isOpen }: IProps) => {
  const { t } = useTranslation();

  const columnDefs = useMemo(() => columnDef(), []);

  return (
    <InventoryDetails
      records={records}
      columnDefs={columnDefs}
      tableId="purchaseOrdersTable"
      entityType="PurchaseOrder"
      title={t('titlePurchaseOrders')}
      onClose={onClose}
      isOpen={isOpen}
    />
  );
};
